
export default function Headlines () {
  return (
    <p className='
      text-[20px]
      w-[500px]
      max-[400px]:w-[300px]
      self-center'
    >Full Stack Software Engineer with Civil Engineering and Project Management experience. Constantly learning, constantly improving, always building.
    </p>
  )
}
